import Icon from '@material-ui/icons/GroupWork';

import Create from './Create';
import Edit from './Edit';
import List from './List';
import Show from './Show';

export default {
  name: 'season',
  icon: Icon,
  list: List,
  show: Show,
  create: Create,
  edit: Edit,
};
